//--------------------------------------------------------
// 1. Developer(s) : Ashitha
// 2. Module/Feature Name :  Privilege Settings
// 3. Developed on : Jun 23, 2017
// 4. Dependencies :  
// 5. Reference Doc name : 
//--------------------------------------------------------

/*To set modules,features and feature privileges for a role*/
class PrivilegeSetting {

    // constructor($scope, $reactive, randomColorService, $state, $stateParams, $mdDialog, UserPrivilages, $location, $anchorScroll, CurrentPage) {
    constructor($scope, $state, $mdDialog, localStorageService, randomColorService, authService, PRIVSETTINGSCONSTANT, $stateParams, $location, $anchorScroll,$rootScope) {
        'ngInject';
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $rootScope.title = "Roles & Privileges Settings"
            if($rootScope.title = "Roles & Privileges Settings"){
                toastr.error("You do not have permission to access this screen.");
                $state.go("dashboard")
            }
        }
        this.$onDestroy = () => {
            $scope.roleList = undefined
            $scope.moduleList = undefined
            $scope.selectedModules = undefined
            $scope.privilegeType = undefined
            $scope.featureRole = undefined
        }
        let dashboardUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
            return feature.module_state == "utilities"
        })

        //To store selected roles from dropdown
        $scope.selectedRoles = [];
        //To store selected modulles from dropdown
        $scope.selectedModules = [];
        //To disable role dropdown once a feature is checked
        $scope.isDisableRole = false;
        // To store  modules
        $scope.moduleList = [];
        // Background colors  for accordion head
        this.color = ["#2db4bd", "#1fbc9b", "#36b3f3"];
        $scope.isSave = true
        $scope.setIndex;

        // To show the proper menu (CRUD) against each feature

        $scope.school_id = localStorageService.get('school_id')
        $scope.privilegeType = [{
            name: "C",
            type: 0

        }, {
            name: "R",
            type: 1
        }, {
            name: "U",
            type: 2
        }, {
            name: "D",
            type: 3
        }]

        /* let role = $stateParams.role*/
        //Role List
        authService.callAPI(PRIVSETTINGSCONSTANT.API_GET_ALL_ROLES + $scope.school_id, "GET", {}, function (response) {
            if (response.result != undefined) {
                if (response.result.data && response.result.data.data && response.result.data.data.length > 0) {
                    $scope.roleList = response.result.data.data[0].roles;
                    if ($stateParams.role_id) {
                        $scope.setSelectBoxWithRole($stateParams.role_id)
                    }
                }
            }
        })
        $scope.setSelectBoxWithRole = function (roleId) {

            let role = _.find($scope.roleList, function (obj) {
                return obj._id == roleId;
            });
            if (role) {
                $scope.selectedRoles.push(role)
                $scope.getAllModules()
            }
        }
        $scope.setSelectBoxWithModule = function (moduleId) {
            let module = _.find($scope.moduleList, function (obj) {
                return obj._id == moduleId;
            });
            $scope.setIndex = $scope.moduleList.findIndex(i => i._id === moduleId)
            $scope.setFeatureIfExitsInServer()
            if (module) {
                $scope.selectedModules.push(module)

                $scope.isDisableRole = true;
                var roleFeature = []
                _.each($scope.selectedRoles, function (role) {
                    var role_feature = _.filter(module.staticFeatureRole, function (each) {
                        return role._id == each.role_id;
                    })

                    _.each(role_feature, function (obj) {
                        roleFeature.push(obj)
                    })
                })
                module.staticFeatureRole = roleFeature
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
        // To choose random colors for accordion
        //arg :null
        //return :string 
        this.getRandomColor = function () {
            return this.color[Math.floor(Math.random() * this.color.length)];
        };
        this.reset = () => {
            if (!($stateParams.role_id && $stateParams.module_id)) {
                _.each($scope.selectedModules, function (obj) {
                    obj.expanded = false
                    obj.expandedright = false
                    obj.featureRoleList = []
                    obj.feature_role = []
                    _.each(obj.features, function (data) {
                        data.status = [false, false, false, false]

                    })
                    /*obj.features=[]*/
                    obj.isDisableFeature = false
                    obj.isEveryFeature = false
                    //obj.name=undefined
                    //obj.school_id=undefined
                    //obj.state=undefined
                    obj.status = false
                    obj.subscription_status = true
                    obj.staticFeatureRole = angular.copy(obj.feature_role)
                    obj.privilegeType = [{
                        name: "C",
                        type: 0,
                        status: false
                    }, {
                        name: "R",
                        type: 1,
                        status: false
                    }, {
                        name: "U",
                        type: 2,
                        status: false
                    }, {
                        name: "D",
                        type: 3,
                        status: false
                    }];

                })
                $scope.selectedRoles = []
                $scope.selectedModules = []
                $scope.moduleList = []
                $scope.isDisableRole = false;
            } else {
                if ($stateParams.role_id) {
                    $scope.selectedModules = []
                    $scope.setSelectBoxWithRole($stateParams.role_id)
                }
            }
        }
        // To open and close accordion on left
        // arg 1: data - object
        $scope.collapseLeft = (data, flag) => {
            // To close all accordions other than the clicked one

            for (var i in $scope.selectedModules) {

                if ($scope.selectedModules[i] != data) {
                    $scope.selectedModules[i].expanded = false;
                }
            }
            data.expanded = !data.expanded;
            if (flag == 0) {
                //$scope.setFeatureIfExitsInServer(data)
                $location.hash(data.state);
                $scope.collapseRight(data, 1)

                $anchorScroll();
            }


        }


        // To open and close accordion on right
        // arg 1: data - Object

        $scope.collapseRight = (data, flag) => {

            // To close all accordions other than the clicked one
            for (var i in $scope.selectedModules) {

                if ($scope.selectedModules[i] != data) {
                    $scope.selectedModules[i].expandedright = false;
                }
            }
            data.expandedright = !data.expandedright;
            var state = data.state + 's'
            if (flag == 0) {
                //$scope.setFeatureIfExitsInServer(data)
                $location.hash(state);
                $scope.collapseLeft(data, 1)

                // call $anchorScroll()
                $anchorScroll();
            }

        }

        //go back to dashboard
        $scope.gobackToDashboard = () => {
            $state.go('privilegeDashboard')
        }
        //To reset the settings of a module
        //arg 1:module - Object of module

        $scope.onModuleChange = (module, index) => {
            $scope.isDisableRole = true;
            var roleFeature = []
            _.each($scope.selectedRoles, function (role) {
                var role_feature = _.filter(module.staticFeatureRole, function (each) {
                    return role._id == each.role_id;
                })

                _.each(role_feature, function (obj) {
                    roleFeature.push(obj)
                })
            })
            module.staticFeatureRole = roleFeature


            //To check whether checkbox is checked or unchecked,true=checkbox unselected,false=checkbox selected
            if (_.contains($scope.selectedModules, module)) {
                //To reset back the  properties of a module
                _.each($scope.selectedModules, function (mod, key) {
                    //to find matching 'module' in selectedModules
                    if (mod._id === module._id) {
                        mod.status = false;
                        mod.isEveryFeature = false;
                        //To reset back the  properties of a feature
                        _.each(mod.features, function (feature) {
                            feature.selected = false;
                            $scope.onAddRemoveFeature(feature, module.state)
                            //feature.status = [false, false, false, false];
                        })
                        //To reset back the  privilegeType array of a module
                        _.each(mod.privilegeType, function (priv) {
                            priv.status = false;
                        })
                        //to remove feature_role added  currently
                        mod.feature_role = _.reject(mod.feature_role, function (item) {
                            return item.is_manual;
                        })
                    }

                })
            }
            $scope.setIndex = index


        }
        //To set features and its crud privileges as such in server
        //arg1 -Object of module
        $scope.setFeatureIfExitsInServer = () => {
            let mod = $scope.moduleList[$scope.setIndex]
            let indexOfModule = $scope.selectedModules.findIndex(i => i._id == mod._id);
            let module = $scope.selectedModules[indexOfModule]
            if (module) {
                _.each(module.features, function (feat) {
                    var features = _.find(module.staticFeatureRole, function (data) {
                        return data.f_id === feat._id
                    })
                    if (features) {
                        feat.selected = true

                        $scope.onAddRemoveFeature(feat, module.state)
                    }
                })
            }

        }
        //To select all features of a particular module
        //arg 1:moduleIndex -String -index of module
        //arg 2:featureIndex -String -index of feature
        $scope.selectAllFeatures = (state, status) => {
        let moduleIndex = $scope.selectedModules.findIndex(i => i.state === state)
            if (status) {
                _.each($scope.selectedModules[moduleIndex].features, function (data) {
                    data.selected = true;
                    $scope.onAddRemoveFeature(data, state)
                })
            } else {

                _.each($scope.selectedModules[moduleIndex].features, function (data) {
                    data.selected = false;
                    $scope.onAddRemoveFeature(data, state)
                })
            }
        }
        // To modify  feature_role array according to feature selection
        //arg1 : feature-Object of feature
        //arg1 : parentIndex- String of moduleList index
        //return null 


        $scope.onAddRemoveFeature = (feature, state) => {
            let parentIndex = $scope.selectedModules.findIndex(i => i.state === state)
            //if role not selected show toast
            if ($scope.selectedRoles.length == 0) {
                toastr.error("Please select role")
                feature.selected = false;
            }
            //if role choosed 
            else {
                //if checkbox against feature is selected , show only those roles in menu, which are in selected roles
                if (feature.selected) {

                    //$scope.isDisableRole = true;


                    //to remove objects from feature_role array whose feature and role ids  are not in selected feature or selected roles
                    if (!$scope.selectedModules[parentIndex].isDisableFeature) {
                        _.each($scope.selectedRoles, function (role) {

                            //to find matching feature_role object
                            let featureRole = _.filter($scope.selectedModules[parentIndex].feature_role, function (item) {

                                return role._id == item.role_id;

                            })
                            //if selected role and feature are already there in feature_role array
                            if (featureRole.length > 0) { //edited as 1 as 0
                                _.each(featureRole, function (each) {
                                    $scope.selectedModules[parentIndex].featureRoleList.push(each);
                                })
                                let havefeatures = _.filter(featureRole, function (item) {

                                    return feature._id == item.f_id;

                                })
                                if (havefeatures.length == 0) {
                                    $scope.selectedModules[parentIndex].featureRoleList.push({
                                        "f_id": feature._id,
                                        "role_id": role._id,
                                        "is_manual": true,
                                        "privilege": [{
                                            "name": "Create",
                                            "status": false,
                                            "type": 0

                                        }, {
                                            "name": "Read",
                                            "status": false,
                                            "type": 1

                                        }, {
                                            "name": "Edit",
                                            "status": false,
                                            "type": 2

                                        }, {
                                            "name": "Delete",
                                            "status": false,
                                            "type": 3

                                        }]

                                    });
                                }

                            }

                            //if selected role ais not in  feature_role array
                            else {
                                $scope.selectedModules[parentIndex].featureRoleList.push({
                                    "f_id": feature._id,
                                    "role_id": role._id,
                                    "is_manual": true,
                                    "privilege": [{
                                        "name": "Create",
                                        "status": false,
                                        "type": 0

                                    }, {
                                        "name": "Read",
                                        "status": false,
                                        "type": 1

                                    }, {
                                        "name": "Edit",
                                        "status": false,
                                        "type": 2

                                    }, {
                                        "name": "Delete",
                                        "status": false,
                                        "type": 3

                                    }]

                                });
                            }
                        });
                        $scope.selectedModules[parentIndex].feature_role = $scope.selectedModules[parentIndex].featureRoleList
                        this.changeCheckBoxAgainstFeatures(parentIndex, feature._id);
                        $scope.selectedModules[parentIndex].isDisableFeature = true;

                    } else {
                        _.each($scope.selectedRoles, function (role) {
                            let res = _.find($scope.selectedModules[parentIndex].featureRoleList, function (each) {
                                return role._id == each.role_id && each.f_id == feature._id;
                            })

                            if (!res) {
                                $scope.selectedModules[parentIndex].featureRoleList.push({
                                    "f_id": feature._id,
                                    "role_id": role._id,
                                    "is_manual": true,
                                    "privilege": [{
                                        "name": "Create",
                                        "status": false,
                                        "type": 0

                                    }, {
                                        "name": "Read",
                                        "status": false,
                                        "type": 1

                                    }, {
                                        "name": "Edit",
                                        "status": false,
                                        "type": 2

                                    }, {
                                        "name": "Delete",
                                        "status": false,
                                        "type": 3

                                    }]

                                })
                                $scope.selectedModules[parentIndex].feature_role = $scope.selectedModules[parentIndex].featureRoleList

                                /*{
                                  {
                                    $scope.selectedModules[parentIndex].status
                                  }
                                }*/

                                if ($scope.selectedModules[parentIndex].status) {
                                    _.each($scope.selectedModules[parentIndex].features, function (obj) {
                                        if (obj._id == feature._id) {
                                            for (var i = 0; i < 4; i++) {
                                                obj.status[i] = true

                                            }
                                        }


                                    })

                                    _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                                        _.each(obj.privilege, function (data) {
                                            data.status = true;
                                        })
                                    })
                                } else {
                                    _.each($scope.selectedModules[parentIndex].privilegeType, function (each) {

                                        if (each.status) {
                                            _.each($scope.selectedModules[parentIndex].features, function (obj) {
                                                if (obj.selected) {
                                                    obj.status[each.type] = true;
                                                }

                                            })
                                            _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                                                _.each(obj.privilege, function (data) {
                                                    if (data.type === each.type) {
                                                        data.status = true
                                                    }
                                                })

                                            })
                                        }
                                    })


                                }
                            }
                        })
                        this.changeCheckBoxAgainstFeatures(parentIndex, feature._id);
                        _.each($scope.privilegeType, function (privilege) {
                            var privilegeCount = 0;
                            _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                                _.each(obj.privilege, function (data) {
                                    if (data.type == privilege.type) {
                                        if (data.status) {
                                            privilegeCount++;
                                        }
                                    }
                                })
                            })
                            if (privilegeCount == $scope.selectedModules[parentIndex].feature_role.length) {
                                var privType = _.find($scope.selectedModules[parentIndex].privilegeType, function (priv) {
                                    return privilege.type === priv.type
                                })
                                privType.status = true;
                            }
                        })
                        var privFilter = _.filter($scope.selectedModules[parentIndex].privilegeType, function (priv) {
                            return priv.status === true
                        })
                        if (privFilter.length == $scope.privilegeType.length) {
                            $scope.selectedModules[parentIndex].status = true;
                        }
                    }
                    // to check whether all features are selected
                    var featureCount = _.filter($scope.selectedModules[parentIndex].features, function (feat) {
                        return feat.selected == true;
                    })
                    if (featureCount.length == $scope.selectedModules[parentIndex].features.length) {
                        $scope.selectedModules[parentIndex].isEveryFeature = true;
                    }
                }
                //if checkbox against feature is unselected
                else {
                    // added to fix internal QA bug no: 4740
                    $scope.selectedModules[parentIndex].featureRoleList = _.reject($scope.selectedModules[parentIndex].featureRoleList, function (item) {

                        return item.f_id === feature._id;
                    })
                    $scope.selectedModules[parentIndex].isEveryFeature = false;

                }
            }

        }
        //This will change all the checkbox values of a module
        //arg1 -status-boolean
        //arg2 -index-string
        $scope.changeAllPrivilege = (status, state) => {
            let index = $scope.selectedModules.findIndex(i => i.state === state)
            if (!status) {
                _.each($scope.selectedModules[index].features, function (obj) {

                    for (var i = 0; i < 4; i++) {
                        obj.status[i] = true

                    }

                })
                _.each($scope.selectedModules[index].privilegeType, function (obj) {
                    obj.status = true
                })
                _.each($scope.selectedModules[index].feature_role, function (obj) {
                    _.each(obj.privilege, function (data) {
                        data.status = true;
                    })
                })
            } else {
                _.each($scope.selectedModules[index].features, function (obj) {
                    for (var i = 0; i < 4; i++) {

                        obj.status[i] = false

                    }
                })
                _.each($scope.selectedModules[index].privilegeType, function (obj) {
                    obj.status = false
                })
                _.each($scope.selectedModules[index].feature_role, function (obj) {
                    _.each(obj.privilege, function (data) {
                        data.status = false;
                    })
                })
            }
        }

        //This will modify role status By Feature and PrivilegeType
        //arg1-status-boolean
        //arg2-id-int
        //arg3-privilege-object

        $scope.changeRolesByFeaturePrivilegeType = (status, id, privilege, state) => {
            let parentIndex = $scope.selectedModules.findIndex(i => i.state === state)
            if (!status) {
                _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                    if (obj.f_id == id) {
                        _.each(obj.privilege, function (data) {
                            if (data.type == privilege.type) {
                                data.status = true
                            }
                        })
                    }

                })
                var privilegeCount = 0;
                _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                    _.each(obj.privilege, function (data) {
                        if (data.type == privilege.type) {
                            if (data.status) {
                                privilegeCount++;
                            }
                        }
                    })
                })
                if (privilegeCount == $scope.selectedModules[parentIndex].feature_role.length) {
                    var privType = _.find($scope.selectedModules[parentIndex].privilegeType, function (priv) {
                        return privilege.type === priv.type
                    })
                    privType.status = true;
                }
                var privFilter = _.filter($scope.selectedModules[parentIndex].privilegeType, function (priv) {
                    return priv.status === true
                })
                if (privFilter.length == $scope.privilegeType.length) {
                    $scope.selectedModules[parentIndex].status = true;
                }
            } else {
                _.each($scope.selectedModules[parentIndex].privilegeType, function (obj) {
                    if (obj.type == privilege.type) {
                        obj.status = false
                    }
                })
                $scope.selectedModules[parentIndex].status = false;
                _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                    if (obj.f_id == id) {
                        _.each(obj.privilege, function (data) {
                            if (data.type == privilege.type) {
                                data.status = false
                            }
                        })
                    }
                })
            }
        }

        //This will modify role status and privilege checkbox against features according to privilegeType
        //arg 1-privilegeType-obj
        /*arg2-index-string*/
        $scope.changeByPrivilegeType = (privilegeType, state) => {
            let index = $scope.selectedModules.findIndex(i => i.state === state)
            if (!privilegeType.status) {
                _.each($scope.selectedModules[index].features, function (obj) {
                    if (obj.selected) {
                        obj.status[privilegeType.type] = true;
                    }

                })
                _.each($scope.selectedModules[index].feature_role, function (obj) {
                    _.each(obj.privilege, function (data) {
                        if (data.type === privilegeType.type) {
                            data.status = true
                        }
                    })

                })
                var privFilter = _.filter($scope.selectedModules[index].privilegeType, function (priv) {
                    return priv.status === true
                })
                if (privFilter.length == $scope.privilegeType.length - 1) {
                    $scope.selectedModules[index].status = true;
                }
            } else {
                $scope.selectedModules[index].status = false;
                _.each($scope.selectedModules[index].features, function (obj) {
                    obj.status[privilegeType.type] = false;
                })
                _.each($scope.selectedModules[index].feature_role, function (obj) {
                    _.each(obj.privilege, function (data) {
                        if (data.type === privilegeType.type) {

                            data.status = false
                        }
                    })

                })
            }
        }
        //To change all parent check box of a role checkbox
        //arg1-status-boolean
        //arg2-id-int
        //arg3-item-object
        //arg4-index-string

        $scope.changedRole = (status, id, item, state) => {
            let index = $scope.selectedModules.findIndex(i => i.state === state)
            if (status) {
                $scope.selectedModules[index].status = false;
                _.each($scope.selectedModules[index].features, function (obj) {
                    if (obj._id == id) {
                        obj.status[item.type] = false;

                    }
                })
                _.each($scope.selectedModules[index].privilegeType, function (obj) {
                    if (obj.type == item.type) {
                        obj.status = false
                    }
                })
            } else {
                let count = 0;
                let featureList = _.filter($scope.selectedModules[index].feature_role, function (obj) {
                    return obj.f_id == id

                })
                _.each(featureList, function (obj) {
                    let object = _.find(obj.privilege, function (obje) {
                        return obje.type == item.type
                    })
                    if (object.status) {
                        count = count + 1;
                    }
                })

                if (count == $scope.selectedRoles.length - 1) {
                    _.each($scope.selectedModules[index].features, function (obj) {
                        if (obj._id == id) {
                            obj.status[item.type] = true;

                        }
                    })
                }
                var privilegeCount = 0;
                _.each($scope.selectedModules[index].feature_role, function (obj) {
                    _.each(obj.privilege, function (data) {
                        if (data.type == item.type) {
                            if (data.status) {
                                privilegeCount++;
                            }
                        }
                    })
                })
                privilegeCount = privilegeCount + 1;
                if (privilegeCount == $scope.selectedModules[index].feature_role.length) {
                    var privType = _.find($scope.selectedModules[index].privilegeType, function (priv) {
                        return item.type === priv.type
                    })
                    privType.status = true;
                }
                var privFilter = _.filter($scope.selectedModules[index].privilegeType, function (priv) {
                    return priv.status === true
                })
                if (privFilter.length == $scope.privilegeType.length) {
                    $scope.selectedModules[index].status = true;
                }
            }

        }
        this.changeCheckBoxAgainstFeatures = function (index, featureId) {
            let featureList = _.filter($scope.selectedModules[index].staticFeatureRole, function (obj) {
                return obj.f_id == featureId

            })

            let indexOfFeature = $scope.selectedModules[index].features.findIndex(i => i._id == featureId);
            _.each($scope.privilegeType, function (item) {
                let count = 0;
                _.each(featureList, function (obj) {
                    let object = _.find(obj.privilege, function (obje) {
                        return obje.type == item.type
                    })
                    if (object.status) {
                        count = count + 1;
                    }
                });


                if (count === $scope.selectedRoles.length) {

                    $scope.selectedModules[index].features[indexOfFeature].status[item.type] = true

                }
            });

        }
        $scope.openMenu = function ($mdOpenMenu, ev, feature,state) {
            let parentIndex = $scope.selectedModules.findIndex(i => i.state === state)
            $mdOpenMenu(ev);
            /* $scope.onAddRemoveFeature(feature, parentIndex);*/
        };
        $scope.onRoleChanged = () => {
            if ($scope.moduleList.length == 0) {
                $scope.getAllModules()
            }
        }

       /************ API CALL TO GET ALL ROLES & THEIR PRIVILEGES ***********/
            /* Function to display roles and their module status.
             * @school_id : String - 
             * @return : List of modules 
             * @Developer : Ashitha
            */
        $scope.getAllModules = () => {
            authService.callAPI(PRIVSETTINGSCONSTANT.API_GET_MODULE_LIST + $scope.school_id, "GET", {}, function (response) {
                if (response.result != undefined) {
                    if (response.result.data && response.result.data.data) {
                        let modules = response.result.data.data;
                        _.each(modules, function (obj) {
                            obj.isDisableFeature = false,
                                obj.featureRoleList = [],
                                obj.staticFeatureRole = angular.copy(obj.feature_role)
                            obj.privilegeType = [{
                                name: "C",
                                type: 0,
                                status: false
                            }, {
                                name: "R",
                                type: 1,
                                status: false
                            }, {
                                name: "U",
                                type: 2,
                                status: false
                            }, {
                                name: "D",
                                type: 3,
                                status: false
                            }];
                            _.each(obj.features, function (data) {
                                data.status = [false, false, false, false]

                            })
                        })
                        _.defer(function () {
                            $scope.$apply();
                        });

                        $scope.moduleList = modules;
                        if ($stateParams.module_id) {
                            $scope.setSelectBoxWithModule($stateParams.module_id)
                        }
                    }
                }
            })
        }




        ///This will save all privilege settings in server
        $scope.saveDetails = (ev) => {
            var isSaved = false
            $scope.isSave = true;

            var count = 0;
            //does n't allow if no module and role is selected
            if ($scope.selectedModules.length > 0 && $scope.selectedRoles.length > 0) {
                _.each($scope.selectedModules, function (obj) {
                    if (obj.featureRoleList.length > 0)
                        count++;
                })
                //doesn't allow if no feature is selected against module
                if (count === $scope.selectedModules.length) {

                    _.each($scope.selectedModules, function (each) {
                        //filter out the selected features 
                        var selectedfeatures = _.filter(each.features, function (obj) {
                            return obj.selected
                        })
                        var featureList = []
                        //filter out 'feature_role' for selected features
                        _.each(selectedfeatures, function (data) {
                            var features = _.filter(each.feature_role, function (obj) {
                                return obj.f_id === data._id
                            })
                            _.each(features, function (fet) {
                                featureList.push(fet)
                            })
                        })
                        //assign filtered feature_role  
                        each.feature_role = featureList
                        var finalList = [];
                        _.each(each.feature_role, function (eachItem) {
                            var counts = 0;
                            //find whether the selected feature is new  or modified 
                            var resObject = _.find(each.staticFeatureRole, function (stat) {
                                return eachItem.role_id === stat.role_id && eachItem.f_id === stat.f_id
                            })
                            //if modified ,then allowing to save
                            if (resObject) {
                                _.each(eachItem.privilege, function (data) {
                                    var objec = _.find(resObject.privilege, function (res) {
                                        return res.name === data.name && res.status === data.status
                                    })
                                    if (objec) {
                                        counts++
                                    }
                                })
                                if (counts != resObject.privilege.length) {
                                    finalList.push(eachItem)
                                }
                            } else {
                                //if new and if any of the 'CRUD' item is true,then allowing to save
                                if (_.compact(_.pluck(eachItem.privilege, 'status')).length > 0) {
                                    finalList.push(eachItem)
                                }
                            }
                            delete eachItem.is_manual
                        })
                        if ($scope.isSave) {
                            if (finalList.length > 0) {
                                each.feature_role = angular.copy(finalList)
                            } else {
                                toastr.error("No changes made in " + each.name)
                                $scope.isSave = false;
                            }
                        }
                    })
                    if ($scope.isSave) {

                        // $scope.loading = true

            /************ API CALL TO CHECK PRIVILEGES EXISTS OR  NOT***********/
            /* Function to check a module exists in default privilges for a particular role.
             * @school_id : String - 
             * @return : List of modules with boolean set
             * @Developer : Ashitha
            */
                        let dataToSend = {
                            module_state: _.pluck($scope.selectedModules, 'state'),
                            roles: $scope.selectedRoles,
                            school_id: localStorageService.get('school_id')
                        }
                        authService.callAPI(PRIVSETTINGSCONSTANT.API_CHECK_PRIVILEGE_EXISTS, "POST", dataToSend, function (response) {
                            var result = response.result.data.data
                            var defaultList = []
                            var stringVar = []
                            _.each(result, function (resObj) {
                                defaultList = result
                                if (resObj.isNewModule) {
                                    stringVar.push(resObj.module_name + " is new Module")
                                } else {
                                    stringVar.push(resObj.module_name + "," + resObj.role_name + " is a new combination.")
                                }
                            })
                            var stringResult = "";
                            _.each(stringVar, function (str) {
                                stringResult = stringResult + str + '</br>'
                            })
                            if (stringVar.length == 0) {
                                stringResult = "Do you want to save??"
                            } else {
                                stringResult = stringResult + "This will save as default privilege."
                            }
                            console.log(stringResult)
                            var confirm = $mdDialog.confirm()
                                .title('Are you sure to continue?')
                                //.htmlContent(stringResult)
                                .ariaLabel('')
                                .targetEvent(ev)
                                .ok('Yes')
                                .cancel('No');

                            $mdDialog.show(confirm).then(function () {
                                $scope.loading = true
                                let objToSend = {
                                    selected_modules: angular.copy($scope.selectedModules),
                                    school_id: localStorageService.get('school_id'),
                                    flag:1
                                }
                            /************ API CALL TO UPDATE PRIVILEGE ***********/
                            /* Function to update  privileges
                             * @school_id : String -
                             * @ selected_modules: List of modules
                             * @return : null
                             * @Developer : Ashitha
                            */
                                authService.callAPI(PRIVSETTINGSCONSTANT.API_UPDATE_PRIVILEGE, "POST", objToSend, function (response) {
                                    $scope.loading = false
                                    isSaved = true
                                    if(response && response.data && response.data.message=="Success")
                                    {
                                        if (defaultList.length == 0) {
                                            if (isSaved) {
                                                $scope.loading = false
                                                toastr.success("Saved Successfully")
                                                $state.go('privilegeDashboard')
                                            }
                                        }
                                    }
                                })
                           
                            /* Function to update default privileges
                             * @school_id : String -
                             * @ selected_modules: List of modules
                             * @return : null
                             * @Developer : Ashitha
                            */
                           let reqObj={
                            selected_modules:angular.copy($scope.selectedModules),
                            default_list:angular.copy(defaultList)
                            
                           }
                            authService.callAPI(PRIVSETTINGSCONSTANT.API_UPDATE_DEFAULT_PRIVILEGE, "POST", reqObj, function (response) {
                                       $scope.loading = false
                                       if(response && response.result && response.result.data && response.result.data.message)
                                       {
                                           if(response.result.data.message==="Success")
                                          toastr.success("Saved Successfully")
                                       }
                                        $state.go('privilegeDashboard')
                                })
                                
                            },
                                function () {
                                    if (defaultList.length > 0) {
                                    $scope.loading = false
                                    let objToSend = {
                                        selected_modules: angular.copy($scope.selectedModules),
                                        school_id: localStorageService.get('school_id'),
                                        flag:1
                                    }
                                    authService.callAPI(PRIVSETTINGSCONSTANT.API_UPDATE_PRIVILEGE, "POST", objToSend, function (response) {
                                        $scope.loading = false
                                        isSaved = true
                                            if (isSaved) {
                                                $scope.loading = false
                                                toastr.success("Saved Successfully")
                                                $state.go('privilegeDashboard')
                                            }
                                        
                                    })
                                }
                                })
                                

                        })

                    } else {
                        toastr.error("Please make any changes and save")
                    }
                } else {
                    toastr.error("Please choose atleast one feature for all selected modules")
                }

            } else {
                if ($scope.selectedRoles.length === 0) {
                    toastr.error("Please select role")
                }
                if ($scope.selectedModules.length === 0) {

                    toastr.error("Please select module")
                }
            }
        }
        /*
         * Sets all default privileges in modules_features
         * 
         * @ev : Object - Click Event
         * 
         * @return : null
         */
        $scope.setSelectedPrivilegeAsDefault = (ev) => {
            if ($scope.selectedModules.length == 0 || $scope.selectedRoles.length == 0) {
                toastr.error("Please select role and module")
            } else {
                var confirm = $mdDialog.confirm()
                    .title('Are you sure to continue?')
                    .textContent('Do you want to set the default privileges?')
                    .ariaLabel('')
                    .targetEvent(ev)
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function () {
                    $scope.loading = true
                    let dataToSend = {
                        module_state: _.pluck($scope.selectedModules, 'state'),
                        roles: $scope.roleList,
                        school_id: localStorageService.get('school_id'),
                        flag:0
                    }
                /************ API CALL TO GET ALL DEFAULT PRIVILEGES ***********/
                /* Function to get all default privileges
                 * @school_id : String - 
                 * @return : modules with default privileges
                 * @Developer : Ashitha
                */
                authService.callAPI(PRIVSETTINGSCONSTANT.API_SET_PRIVILEGE_DEFAULT, "POST", dataToSend, function (response) {  
                    let result = response.result.data.data
                        if (result.length > 0) {
                            var selectedModules = result
                            _.each(selectedModules, function (each) {
                                var finalList = [];
                                _.each(each.feature_role, function (eachItem) {
                                    var counts = 0;
                                    var resultModule = _.find($scope.selectedModules, function (mod) {
                                        return each.state === mod.state
                                    })
                                    //find whether the selected feature is new  or modified 
                                    if (resultModule) {
                                        var resObject = _.find(resultModule.staticFeatureRole, function (stat) {
                                            return eachItem.role_id === stat.role_id && eachItem.f_id === stat.f_id
                                        })
                                    }
                                    //if modified ,then allowing to save
                                    if (resObject) {
                                        _.each(eachItem.privilege, function (data) {
                                            var objec = _.find(resObject.privilege, function (res) {
                                                return res.name === data.name && res.status === data.status
                                            })
                                            if (objec) {
                                                counts++
                                            }
                                        })
                                        if (counts != resObject.privilege.length) {
                                            finalList.push(eachItem)
                                        }
                                    } else {
                                        //if new and if any of the 'CRUD' item is true,then allowing to save
                                        if (_.compact(_.pluck(eachItem.privilege, 'status')).length > 0) {
                                            finalList.push(eachItem)
                                        }
                                    }

                                })

                                each.feature_role = angular.copy(finalList)

                            })
                            if (selectedModules) {
                                  /************ API CALL TO UPDATE PRIVILEGE ***********/
                            /* Function to update  privileges
                             * @school_id : String -
                             * @ selected_modules: List of modules
                             * @return : null
                             * @Developer : Ashitha
                            */
                            let objToSend = {
                                selected_modules: angular.copy(selectedModules),
                                school_id: localStorageService.get('school_id'),
                                flag:1
                                }
                               authService.callAPI(PRIVSETTINGSCONSTANT.API_UPDATE_PRIVILEGE, "POST", objToSend, function (response) {
                                if(response &&response.result && response.result.data && response.result.data.message=="Success")
                                {        
                                        $scope.loading = false
                                        toastr.success("Successfully added")
                                        $state.go('privilegeDashboard')
                                }
                                else{
                                    $scope.loading = false
                                    toastr.error("Try again")
                                }
                             })
                            }
                          } else {
                            $scope.loading = false
                            toastr.error("Default privileges not found")
                        }
                        _.defer(function () {
                            $scope.$apply();
                        });
                    })

                })
            }

        }
    }
}
export default PrivilegeSetting;


// WEBPACK FOOTER //
// ./src/app/privilege/controllers/privilegeSettingsController.js